import { api } from "../index";

export const registrationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postRegistration: builder.mutation({
      query: (data) => ({
        url: "/api/v1/signup",
        method: "POST",
        body: data,
      }),
    }),
    postRegistrationSubmit: builder.mutation({
      query: ({ token, data }) => ({
        url: `/api/v1/signup/${token}/submit`,
        method: "POST",
        body: data,
      }),
    }),    
    patchRegistration: builder.mutation({
      query: ({ token, data }) => ({
        url: `/api/v1/signup/${token}`,
        method: "PATCH",
        body: data,
      }),
    }),
    
    getRegistration: builder.query({
      query: (token) => `/api/v1/signup/${token}`,
    }),
    
    verifyOtp: builder.mutation({
      query: ({ token, otp_code }) => ({
        url: `/api/v1/signup/${token}/verify_otp`,
        method: "POST",
        body: { otp_code },
      }),
    }),

    resendOtp: builder.mutation({
      query: ({ token }) => ({
        url: `/api/v1/signup/${token}/resend_otp`,
        method: "POST",
      }),
    }),

    getPaymentStatus: builder.mutation({
      query: ({ token }) => ({
        url: `/api/v1/signup/payment_status`,
        method: "POST",
        body: { token },
      }),
    }),
    verifyInviteToken: builder.query({
      query: (token) => `/api/v1/signup/business_lead/${token}`,
    }),
    checkEmail: builder.mutation({
      query: (email) => ({
        url: `/api/v1/signup/emails/${email}/availability`,
        method: "GET",
      }),
    }),

    checkEmailAvailability: builder.query({
      query: (email) => `/api/v1/signup/emails/${email}/availability`,
      transformResponse: (response) => response,
    }),
  }),
});

export const { 
  usePostRegistrationMutation, 
  usePatchRegistrationMutation,
  usePostRegistrationSubmitMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useGetPaymentStatusMutation,
  useGetRegistrationQuery,
  useVerifyInviteTokenQuery,
  useCheckEmailMutation,
  useLazyCheckEmailAvailabilityQuery,
} = registrationApi;
